<template>
  <div class="modal fade " ref="campaignMessagesModel" id="campaignMessagesModel">
    <div class="modal-dialog">
      <div class="modal-content" style="width: 1200px">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title w-100">{{ $t('orders.messages') }}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <div class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
              <label for="msgType" class="sr-only">{{ $t('orders.newMsg') }} </label>
              <div class="col-md-3 pr-0">
                <!-- Choose message type -->
                <select class="form-control" id="whatsappMsgType" ref="whatsappMsgType" @change="requestWhatsappMsg()">
                  <option selected disabled>{{ $t('orders.msgType') }}</option>
                  <option v-for="msg in messages" v-if="msg.isShowMessage"
                          :value="msg.id">
                    {{ msg.displayName }}
                  </option>
                </select>
              </div>
              <!-- Message body -->
              <form @submit.prevent="sendMsg" class=" mb-2">


                <button v-if="isSelectedMessage && !hideBtn" type="submit" class="btn btn-color-1">
                  {{ $t('orders.submit') }}
                </button>
                <p v-if="countOfResultStatus" class="text-success font-weight-bold"><span>{{countOfResultStatus}} </span><span>הודעות, נמצאים בסטטוס המתנה</span></p>
              </form>

              <div class="col-12" v-if="error">
                <p class="text-danger">{{error}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import loader from "@/components/loader.vue";
import formControl from "@/components/formcontrol.vue";
import Multiselect from "vue-multiselect";

export default {

  components: {Multiselect, formControl, loader},
  name: 'CampaignMessages',
  props: {
    messages: Array,
    rows: Array,
    previewOrderList: Array,
    isOpenWhatsappModal: Boolean,
    campaignKind: String,
    model: String,
  },

  data() {
    return {
      msg: {
        msgType: 'whatsapp',
        messageId: '',
        subject: '',
        campaign_id: '',
        isEditable: '',
        content: '',
        messageKind: '',
        model: this.model,
        rows: this.rows,
      },
      isSelectedMessage: false,
      statusId: '',
      hideBtn: false,
      countOfResultStatus: 0,
      error: '',

    }
  },

  methods: {
    requestWhatsappMsg() {
      let id = this.$refs.whatsappMsgType.value;
      for (let i in this.messages) {
        if (this.messages[i].id === parseInt(id)) {
          this.isSelectedMessage = true;
          this.msg.messageId = parseInt(id)
          this.msg.subject = this.messages[i].subject;
          this.msg.campaign_id = this.messages[i].campaign_id;
          this.msg.isEditable = this.messages[i].isEditable ? true : false;
          this.msg.content = this.messages[i].content;
          this.msg.messageKind = this.messages[i].messageKind;
          this.msg.whatsappTemplateName = this.messages[i].whatsappTemplateName;

        }
      }
      this.msg.previewOrderList = this.previewOrderList;
    },

    sendMsg() {
      if(!this.msg.whatsappTemplateName || !this.msg.content || !this.msg.campaign_id) {
        this.error = 'יש לבדוק שלהודעה יש תוכן/שם של טמפלט/קמפיין ID'
      }


      let prefix = this.campaignKind;
      let that = this;
      if (confirm(`${this.previewOrderList.length} רשומות עומדים להישלח, האם להמשיך ? `)) {
        this.hideBtn = true;
        axios.post(`${prefix}/sendMessage`, that.msg)
          .then((res) => {
            const arrFromObj = Object.keys(res.data.data['res_status']);
            that.countOfResultStatus = arrFromObj.length

          }).catch((err) => {
          this.hideBtn = false;
          this.$emit('alert', 'danger', err.response.data.status)
        })
      } else {
        //this.hideBtn = false;
        this.closeModal();
      }
    },
    closeModal() {
      let element = that.$refs.campaignMessagesModel
      $(element).modal('hide')
    }

  }
}

</script>


